//reducer for sharebot enable and disable

const initialState = {
    showShareBot: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case 'ENABLE_SHAREBOT':
            return {
                showShareBot: true
            }
        case 'DISABLE_SHAREBOT':
            return {
                showShareBot: false
            }
        default:
            return state
    }
}